
import React from 'react';

const Loader = () => {
    return (
        <div className="d-flex justify-content-center align-items-center" style={{ minHeight: '200px' }}>
            <div className="spinner-border text-primary" role="status">
                <span className="visually-hidden">Cargando...</span>
            </div>
            <p className="ms-2 mb-0">Cargando...</p>
        </div>
    );
};

export default Loader;
